<template>
  <app-content
    class="editor__page"
    :style="{ color }"
    :content="translate(text)"
  />
</template>

<script setup>
import { useI18n } from '@/vendors/i18n'
import { useStyle } from '@/composables/app/useStyle'

import AppContent from '&/atoms/AppContent'

const { parent, component } = defineProps({
  parent: { type: Object, required: true },
  component: { type: Object, required: true }
})

const { componentStyle: parentStyle } = useStyle(parent.style)
const { componentStyle: blockStyle } = useStyle(component.style)
const { translate } = useI18n()

const { text } = component.attributes
const color = blockStyle.value.color || parentStyle.value.color
</script>
